<template>
    <header class="header-wrapper" :class="{
        'bg1':targetIdx===0,
        'bg2':targetIdx===1,
        'bg3':targetIdx===2
        }">
        <div class="video-wrapper">
            <video ref="headerVideo" width="100%" height="100%" muted preload playsinline
            v-if="targetIdx === 0">
                <source src="@/assets/video/title_mob_1.mp4" type="video/mp4"
                v-if="!isPc">
                <source src="@/assets/video/title_pc_1.mp4" type="video/mp4"
                v-else>
            </video>
            <video ref="headerVideo" width="100%" height="100%" muted preload playsinline
            v-if="targetIdx === 1">
                <source src="@/assets/video/title_mob_2.mp4" type="video/mp4"
                v-if="!isPc">
                <source src="@/assets/video/title_pc_2.mp4" type="video/mp4"
                v-else>
            </video>
            <video ref="headerVideo" width="100%" height="100%" muted preload playsinline
            v-else-if="targetIdx === 2">
                <source src="@/assets/video/title_mob_3_XL.mp4" type="video/mp4"
                v-if="!isPc && isBigMob">
                <source src="@/assets/video/title_mob_3.mp4" type="video/mp4"
                v-else-if="!isPc">
                <source src="@/assets/video/title_pc_3.mp4" type="video/mp4"
                v-else>
            </video>
        </div>
    </header>
</template>

<script>
import mixinMethod from '@/js/mixin/mixinMethod';

export default {
    name: 'MainHeader',
    props: {
        name: {
            type: String,
            default: '',
        },
        date: {
            type: String,
            default: '',
        },
        isPlayHeader: {
            type: Boolean,
        },
        targetIdx: {
            type: Number,
        },
    },
    data() {
        return {
            isPc: window.innerWidth > 768,
        };
    },
    mounted() {
        this.isPc = window.innerWidth > 768;
    },
    methods: {
    },
    computed: {
        isIOS() {
            return /iPad|iPhone|iPod/.test(navigator.userAgent);
        },
        isBigMob() {
            if (this.isIOS) {
                return window.screen.width > 380 && window.screen.width <= 768;
            }
            return window.innerWidth > 380 && window.innerWidth <= 768;
        },
    },
    watch: {
        isPlayHeader(val) {
            const video = this.$refs.headerVideo;
            if (val) {
                window.setTimeout(() => {
                    if (video) video.play();
                }, 500);
                return;
            }
            if (video) {
                video.pause();
                video.currentTime = 0;
            }
        },
        targetIdx(val) {
            if (val > 2) return;
            window.setTimeout(() => {
                const video = this.$refs.headerVideo;
                if (video) video.play();
            }, 500);
        },
    },
    mixins: [mixinMethod],
};
</script>
